import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { UserCheck, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaContratacaoIniciada = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    return acaoLower.includes('contratação de profissional iniciada') || 
           acaoLower.includes('contratacao de profissional iniciada') ||
           acaoLower.includes('encaminhou para contratação') ||
           acaoLower.includes('encaminhou para contratacao') ||
           acaoLower.includes('triagem concluída') ||
           acaoLower.includes('triagem concluida');
};

const getIconContratacaoIniciada = (acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: UserCheck, color: 'var(--c8b5cf6)' };
};

export default function CardContratacaoIniciada({ 
    item, 
    onNavigateToFile, 
    isExpanded, 
    onToggleExpand 
}: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconContratacaoIniciada(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={
                <ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />
            }
        />
    );
}

export const contratacaoIniciadaConfig = {
    tipo: 'contratacao_iniciada',
    detectaTipo: detectaContratacaoIniciada,
    getIcon: getIconContratacaoIniciada,
    temExpansao: () => true,
    Component: CardContratacaoIniciada
};

